/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospects_ProspectEmailTemplateSummaryResponse = {
    /**
     * Label is the German fallback label. Clients render their own localized label
     * keyed on TemplateKey and use this only for an unrecognised key.
     */
    label: string;
    language: string;
    source: prospects_ProspectEmailTemplateSummaryResponse.source;
    template_key: string;
};
export namespace prospects_ProspectEmailTemplateSummaryResponse {
    export enum source {
        ORG = 'org',
        DEFAULT = 'default',
    }
}

